import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isTransferProjectResourceAllocationsRequestFailure(
      project,
      fromProjectResource,
      toProjectResource,
    ) {
      const state = getState().find(
        (res) =>
          res.project.uuid === project.uuid &&
          res.fromProjectResource.uuid === fromProjectResource.uuid &&
          res.toProjectResource.uuid === toProjectResource.uuid,
      );

      return state ? state.request.isFailure : false;
    },
    isTransferProjectResourceAllocationsRequestPending(
      project,
      fromProjectResource,
      toProjectResource,
    ) {
      const state = getState().find(
        (res) =>
          res.project.uuid === project.uuid &&
          res.fromProjectResource.uuid === fromProjectResource.uuid &&
          res.toProjectResource.uuid === toProjectResource.uuid,
      );

      return state ? state.request.isPending : false;
    },
    isTransferProjectResourceAllocationsRequestSuccess(
      project,
      fromProjectResource,
      toProjectResource,
    ) {
      const state = getState().find(
        (res) =>
          res.project.uuid === project.uuid &&
          res.fromProjectResource.uuid === fromProjectResource.uuid &&
          res.toProjectResource.uuid === toProjectResource.uuid,
      );

      return state ? state.request.isSuccessful : false;
    },
  };
}

export { createSelector };
